import React from "react";
import { isTablet, isMobile } from "react-device-detect";

import Stack from "@mui/material/Stack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Loader from "components/Loader";

import ErrorPage from "../../components/ErrorPage";
import PageNetBackground from "../../components/PageNetBackground";

import InfoModal from "./InfoModal";
import IbanInfoDisplay from "./IbanInvoiceDisplay";

import { useIbanQr } from "./useIbanQr";

import { styles } from "./styles";

const IbanQr: React.FC = () => {
  const {
    iban,
    isIbanLoading,
    errorText,
    showModal,
    isBankLoading,
    preferredBank,
    paymentUrl,
    currentBankRef,
    onCloseModal,
    handlePayment,
  } = useIbanQr();

  const showMobileContent = isMobile || isTablet;

  if (isIbanLoading) {
    return <Loader isLoadingPage />;
  }

  if (errorText) {
    return (
      <ErrorPage
        message="На жаль, це посилання для оплати більше недоступне."
        subMessage={errorText}
      />
    );
  }

  return (
    <PageNetBackground sx={styles.page} contentSx={styles.children}>
      <InfoModal
        open={showModal}
        onClose={onCloseModal}
        url={iban?.ibanInvoiceUrl || ""}
        showChromeButton={!!currentBankRef.current}
      />
      <Backdrop sx={{ zIndex: 1000 }} open={isBankLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack direction="column" gap={1} sx={{ pt: { xs: 2, md: 10 }, pb: 10 }}>
        <IbanInfoDisplay
          iban={iban}
          paymentUrl={paymentUrl}
          preferredBank={preferredBank}
          handlePayment={handlePayment}
          isMobile={showMobileContent}
        />
      </Stack>
    </PageNetBackground>
  );
};

export default IbanQr;
